import React from "react";
import styles from '../HelpPage.module.css';

const Instructions = () => {
    return (
        <section className={styles.helpSection}>
        <h2>Instructions</h2>
        {/* ... your instruction paragraphs ... */}
        <p>
            Welcome to the EcomBuddha Help Center! Here you'll find information on how to use the various features of the platform.
        </p>
        <p>
            <strong>Generating Listings:</strong> Navigate to "Generate Content" in the sidebar. Choose between single, bulk, image, or copy-only generation. Follow the prompts on each page to input your product details.
        </p>
        <p>
            <strong>History:</strong> Access your previously generated content and tasks in the "History" section.
        </p>
        <p>
            <strong>Profile Settings:</strong> Manage your account details and change your password under "Profile Settings" accessible from the top-right user icon.
        </p>
        <p>
            <strong>Credits:</strong> Your remaining credits are displayed in the top navigation bar. Credits are used for generating content and images.
        </p>
    </section>
    );
};

export default Instructions;